module.exports = __webpack_public_path__ + "resources/img/img-acra-point-01-en.14e8456c4cd679a52302c2ee012a72e6.png";